import { category } from "./category";
import { chart } from "./chart";
import { metadata } from "./metadata";

export const financialMetrics = {
  zh: {
    backLink: (title: string) => `回 ${title}`,
    category: category.zh,
    chart: chart.zh,
    metadata: metadata.zh,
  },
  en: {
    backLink: (title: string) => `Back to ${title} Analysis`,
    category: category.en,
    chart: chart.en,
    metadata: metadata.en,
  },
};
